// Read more about this way of fetching data
// https://redux.js.org/advanced/async-actions#actions-js-with-fetch

import {
  loadTerminalRequest,
  loadTerminalSuccess,
  loadTerminalFailure,
  loadNewTerminalRequest,
  loadNewTerminalSuccess,
  loadNewTerminalFailure,
  submitTerminalSwitchRequest,
  submitTerminalSwitchSuccess,
  submitTerminalSwitchFailure,
  goNextTerminalSwitchStep,
  goFirstTerminalSwitchStep,
  goBackTerminalSwitchStep,
  goToTerminalSwitchStep,
  resetTerminalSwitch,
  changeTerminalSwitchMode
} from './actionCreators';
import fetch from 'cross-fetch'


export function goNextStep(newModeNum) {
  return (dispatch, getState) => {
    let state = getState();
    if (newModeNum === 0) { newModeNum = state.terminalSwitch.activeStepState.activeStepMode; }
    let newActiveStepNum = state.terminalSwitch.activeStepState.activeStepNum + 1;
    let newStepState = {
      activeStepNum: newActiveStepNum,
      activeStepMode: newModeNum
    }
    dispatch(goNextTerminalSwitchStep(newStepState));
  }
}

export function goToStep(newStepNum, newModeNum) {
  return (dispatch) => {
    let newStepState = {
      activeStepNum: newStepNum,
      activeStepMode: newModeNum
    }
    dispatch(goToTerminalSwitchStep(newStepState));
  }
}

export function changeMode() {
  return (dispatch, getState) => {
    let state = getState();
    let currentModeNum = state.terminalSwitch.activeStepState.activeStepMode;
    let currentStepNum = state.terminalSwitch.activeStepState.activeStepNum;
    let newModeNum = 1;
    if (currentModeNum === 1) { newModeNum = 2} 
    let newStepState = {
      activeStepNum: currentStepNum,
      activeStepMode: newModeNum
    }
    dispatch(changeTerminalSwitchMode(newStepState));
  }
}


export function goBackStep() {
  return (dispatch, getState) => {
    let state = getState();
    
    let newActiveStepNum = state.terminalSwitch.activeStepState.activeStepNum - 1;
    let newStepState = {
      activeStepNum: newActiveStepNum,
      activeStepMode: state.terminalSwitch.activeStepState.activeStepMode
    }
    dispatch(goBackTerminalSwitchStep(newStepState));
  }
}

export function goFirstStep() {
  return (dispatch) => {
    let stepState = {
      activeStepNum: 0,
      activeStepMode: 0
    }
    dispatch(resetTerminalSwitch());
    dispatch(goFirstTerminalSwitchStep(stepState));
  }
}

export function resetTerminalSwitchState() {
  return (dispatch) => {
    dispatch(resetTerminalSwitch());
  }
}

export function loadOldTerminal(terminalCode) {
  return (dispatch, getState) => {
    let state = getState();
    let token = state.oidc.user.access_token;

    dispatch(loadTerminalRequest());
    return fetch(process.env.API_URL + '/api/TerminalSwitch/' + terminalCode, {
        headers: {
          'Authorization': 'Bearer ' + token
        }
      })
      .then(response => {
        if (response.ok) {
          return response.json()
        } else {
          return Promise.reject({
            status: response.status,
            statusText: response.statusText
          });
        }
      })
      .then(json => dispatch(loadTerminalSuccess(json)))
      .catch(error => {
        console.log(error.status);
        if (error.status === 404 || error.status === 500) {
          dispatch(loadTerminalFailure("Virhe"))
        }
      })
  }
}

export function loadNewTerminal(terminalCode) {
  return (dispatch, getState) => {
    let state = getState();
    let token = state.oidc.user.access_token;

    dispatch(loadNewTerminalRequest());
    return fetch(process.env.API_URL + '/api/TerminalSwitch/' + terminalCode, {
        headers: {
          'Authorization': 'Bearer ' + token
        }
      })
      .then(response => {
        if (response.ok) {
          return response.json()
        } else {
          return Promise.reject({
            status: response.status,
            statusText: response.statusText
          });
        }
      })
      .then(json => dispatch(loadNewTerminalSuccess(json)))
      .catch(error => {
        console.log(error.status);
        if (error.status === 404 || error.status === 500) {
          dispatch(loadNewTerminalFailure("Virhe"))
        }
      })
  }
}

export function submitTerminalSwitch(terminalCodeOld, terminalCodeNew) {
  return (dispatch, getState) => {
    let content = {
      terminalCodeOld: terminalCodeOld,
      terminalCodeNew: terminalCodeNew
    };
    let state = getState();
    let token = state.oidc.user.access_token;
    dispatch(submitTerminalSwitchRequest());
    return fetch(process.env.API_URL + '/api/TerminalSwitch/', {
        method: 'POST',
        body: JSON.stringify(content),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })
      .then(response => {
        if (response.ok) {
          dispatch(submitTerminalSwitchSuccess());
          let newActiveStepNum = state.terminalSwitch.activeStepState.activeStepNum + 1;
          let newStepState = {
            activeStepNum: newActiveStepNum,
            activeStepMode: 0
          }
            dispatch(goNextTerminalSwitchStep(newStepState));
        } else {
          return Promise.reject({
            status: response.status,
            statusText: response.statusText
          });
        }
      })
      .catch(error => {
          dispatch(submitTerminalSwitchFailure("Virhe"))
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/terminalSwitchActions.js